import React, { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { SGSFileInput, SGSFileInputProps } from 'components';
import { useTranslation } from 'react-i18next';

type Props = SGSFileInputProps & {
    imagePathFieldName?: string;
};

const SGSFormFileInput: React.FC<Props> = ({ imagePathFieldName, onDeleteImage, name, label, ...props }) => {
    const { control, getValues } = useFormContext();
    const { t } = useTranslation();
    const [isImageDeleted, setIsImageDeleted] = useState(false);
    const handleDeleteImage = () => {
        setIsImageDeleted(true);
        onDeleteImage();
    };
    return (
        <Controller
            {...props}
            name={name}
            control={control}
            render={({ field: { onChange, value, ...field }, fieldState: { error } }) => (
                <SGSFileInput
                    {...field}
                    label={t(label as string)}
                    error={!!error}
                    helperText={error?.message ?? ''}
                    image={!isImageDeleted && imagePathFieldName && getValues(imagePathFieldName)}
                    onDeleteImage={handleDeleteImage}
                    value={value?.filename}
                    onChange={(event) => onChange((event.target as any).files[0])}
                />
            )}
        />
    );
};

export default SGSFormFileInput;
